import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeVolunteerPopup } from "../features/volunteerPopupSlice.js";
import { createVolunteer } from "../features/PublicAPIsService.js";
// import ImgBanner from "../../assets/VolunteerFormPNG.webp";
const ImgMobileBanner = "https://d28w88on64rtni.cloudfront.net/ChatGPT+Image+Apr+29%2C+2026%2C+12_47_05+AM.webp";

const  ImgBanner = "https://d28w88on64rtni.cloudfront.net/ChatGPT+Image+Apr+29%2C+2026%2C+12_28_10+AM.webp";

const VolunteerFormPopup = () => {
  // const isMobile = window.innerWidth <= 768;
  
  const dispatch = useDispatch();

  const isOpen = useSelector((state) => state.volunteerPopup.isOpen);
  const {
    volunteerLoading,
    volunteerError,
  } = useSelector((state) => state.PublicAPIsService);

  const [isClosing, setIsClosing] = useState(false);
  const [success, setSuccess] = useState(false);
const [isMobile, setIsMobile] = useState(window.innerWidth <= 780);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 780);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);
  const [form, setForm] = useState({
    name: "",
    email: "",
    address: "",
    phoneNumber: "",
  });

  const [errors, setErrors] = useState({});

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      dispatch(closeVolunteerPopup());
      setIsClosing(false);
      setSuccess(false);
      setForm({
        name: "",
        email: "",
        address: "",
        phoneNumber: "",
      });
      setErrors({});
    }, 400);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) handleClose();
  };

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
    setErrors({ ...errors, [field]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!form.name.trim()) newErrors.name = "Name required";
    if (!form.email.trim()) newErrors.email = "Email required";
    if (!form.address.trim()) newErrors.address = "Address required";

    if (!form.phoneNumber) {
      newErrors.phoneNumber = "Phone number required";
    } else if (!/^[0-9]{10}$/.test(form.phoneNumber)) {
      newErrors.phoneNumber = "Enter valid 10-digit phone number";
    }

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    const res = await dispatch(createVolunteer(form));

    if (res.payload?.success) {
      setSuccess(true);
      setTimeout(handleClose, 2000);
    }
  };

  if (!isOpen && !isClosing) return null;

  return (
    <>
      <div
        className={`volunteer-popup-overlay ${isClosing ? "closing" : ""}`}
        onClick={handleOverlayClick}
      >
        <div className={`volunteer-popup-container ${isClosing ? "closing" : ""}`}>
          <button className="volunteer-close-btn" onClick={handleClose}>
            ✕
          </button>

          {/* LEFT IMAGE */}
          <div className="volunteer-popup-image">
            {/* <img src={ImgBanner} alt="Volunteer" /> */}
            
            {/* <img src={ImgBanner} alt="Volunteer" /> */}

  {/* <img className="desktop-banner" src={ImgBanner} alt="Volunteer" />
  <img className="mobile-banner" src={ImgMobileBanner} alt="Volunteer" /> */}
    <img
    src={isMobile ? '/images/volunteerMobileImage.webp' : '/images/voulenteerImage.webp'}
    alt="Volunteer"
  />
          </div>

          {/* RIGHT FORM */}
          <div className="volunteer-popup-form">
            <h2>Be the Hands of Seva</h2>
            <p>To volunteer is to lend your hands to a vision greater than yourself, and your heart to a legacy that will outlast us all.</p>

            {success ? (
              <div className="volunteer-success-box">
                Thank you for volunteering!
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="volunteer-form-group">
                  <input
                    placeholder="Name"
                    value={form.name}
                    onChange={(e) => handleChange("name", e.target.value)}
                  />
                  {errors.name && <span>{errors.name}</span>}
                </div>

                <div className="volunteer-form-group">
                  <input
                    type="email"
                    placeholder="Email"
                    value={form.email}
                    onChange={(e) => handleChange("email", e.target.value)}
                  />
                  {errors.email && <span>{errors.email}</span>}
                </div>

                <div className="volunteer-form-group">
                  <input
                    type="tel"
                    placeholder="Phone Number"
                    maxLength={10}
                    value={form.phoneNumber}
                    onChange={(e) =>
                      handleChange(
                        "phoneNumber",
                        e.target.value.replace(/\D/g, "")
                      )
                    }
                  />
                  {errors.phoneNumber && (
                    <span>{errors.phoneNumber}</span>
                  )}
                </div>

                <div className="volunteer-form-group">
                  <textarea
                    placeholder="Full Address"
                    value={form.address}
                    onChange={(e) =>
                      handleChange("address", e.target.value)
                    }
                  />
                  {errors.address && <span>{errors.address}</span>}
                </div>

                {volunteerError && (
                  <p className="volunteer-error">{volunteerError}</p>
                )}

                <button
                  className="volunteer-submit-btn"
                  disabled={volunteerLoading}
                >
                  {volunteerLoading ? "Submitting..." : "Submit"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>


            <style jsx>{`
/* Overlay */
.volunteer-popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.4s ease;
}

.volunteer-popup-overlay.closing {
  animation: fadeOut 0.4s ease forwards;
}

/* Popup Container */
.volunteer-popup-container {
z-index:999999;
  width: 92%;
  max-width: 960px;
  background: linear-gradient(
    135deg,
    var(--Background-light-Color),
    var(--Background-Dark-Color)
  );
  display: grid;
  grid-template-columns: 45% 55%;
  border-radius: 18px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.45);
  animation: slideIn 0.5s ease;
}

.volunteer-popup-container.closing {
  animation: slideOut 0.4s ease forwards;
}

/* Close Button */
.volunteer-close-btn {
  position: absolute;
  top: 16px;
  right: 18px;
  font-size: 2rem;
  background: none;
  border: none;
  color: var(--PrimaryFont-Color);
  cursor: pointer;
  z-index: 10;
}

/* Left Image */
.volunteer-popup-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.85);
}

/* Right Form */
.volunteer-popup-form {
  padding: 3rem 2.8rem;
  font-family: var(--Body-Font);
  color: var(--PrimaryFont-Color);
}

.volunteer-popup-form h2 {
  font-family: var(--Heading-Font) !important;
  font-size: var( --SectionHeading-Font_Size);
  color: var( --InputText-Color);
  margin-bottom: 0.3rem;
}

.volunteer-popup-form p {
  font-size: var(--Para-Graph-Font_Size);
  color: var(--InputText-Color);
  margin-bottom: 1.8rem;
}

/* Form Group */
.volunteer-form-group {
  margin-bottom: 1.1rem;
}

.volunteer-form-group label {
  display: block;
  font-size: var(--Para-Graph-Font_Size);
  margin-bottom: 0.35rem;
  color: var(--InputText-Color);
}

.volunteer-form-group input,
.volunteer-form-group textarea {
  width: 100%;
  padding: 0.75rem 0.9rem;
  font-size: var(--Para-Graph-Font_Size);
  background: transparent;
  border:none;
  border-bottom: 1px solid var(--InputText-Color);

  color: var(--InputText-Color);
  outline: none;
  transition: all 0.25s ease;
}

.volunteer-form-group textarea {
  resize: none;
  min-height: 80px;
}
.volunteer-form-group input::placeholder,
.volunteer-form-group textarea::placeholder {
  color: var(--InputText-Color); 
  opacity: 0.75;
}


.volunteer-form-group input:focus,
.volunteer-form-group textarea:focus {
  border-color: var(--InputText-Color);
  background: rgba(255, 255, 255, 0.05);
}

.volunteer-form-group span {
  font-size: 0.7rem;
  color: var(--Btn-Color);
}

.volunteer-error {
  font-size: 0.8rem;
  color: var(--Btn-Color);
  margin-bottom: 0.5rem;
}

.volunteer-submit-btn {
  width: 100%;
  margin-top: 1rem;
  padding: 0.85rem;
  background: var(--Btn-Color);
  color: var(--Btn-Font-Color);
  font-size: var(--Btn-Font-Size);
  font-family: var(--Body-Font);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}


.volunteer-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.volunteer-success-box {
  padding: 1.2rem;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid var(--Font-Color-Light-Yellow);
  color: var(--Font-Color-Light-Yellow);
  text-align: center;
  border-radius: 8px;
  font-family: var(--Heading-Font);
}

@keyframes fadeIn {
  from { opacity: 0 }
  to { opacity: 1 }
}

@keyframes fadeOut {
  to { opacity: 0 }
}

@keyframes slideIn {
  from { transform: translateY(30px) scale(0.95); opacity: 0 }
  to { transform: translateY(0) scale(1); opacity: 1 }
}

@keyframes slideOut {
  to { transform: translateY(40px) scale(0.9); opacity: 0 }
}

@media (max-width: 768px) {
  .volunteer-popup-container {
    grid-template-columns: 1fr;
    margin-top: 3rem;
        grid-template-columns: 1fr;
        max-height: 70vh;
        overflow-y: scroll;
  }

  .volunteer-popup-image {
    height: 250px;
  }

  .volunteer-popup-form {
    padding: 2rem 1.5rem;
  }
    .volunteer-close-btn {
  
  color: var(--Heading-Color);
}
}
`}</style>
    </>
  );
};

export default VolunteerFormPopup;
